export const sectionIds = {
  nav: "nav",
}
